// Planilha da manhã: preços que alguém sobe direto na Ameixa antes de a tela começar a ser usada.
// A API devolve, por produto, o P. Médio e o P. Maior SKU da planilha; o reset da tela parte deles.

export const valoresDaPlanilha = (base, productBaseId) => {
  const produto = base?.disponivel ? base.produtos?.[productBaseId] : null;
  if (!produto) return null;
  // Sem um dos dois preços não há referência: Number(null) viraria R$ 0,00 no campo.
  if (produto.preco_medio == null || produto.preco_maior_sku == null) return null;
  // Centavos, como o campo mostra: com mais casas, clicar e sair do campo viraria "editado".
  // Booleano não é preço (Number(true) seria R$ 1,00): vira NaN e cai na validação abaixo.
  const centavos = valor =>
    typeof valor === "boolean" ? NaN : Math.round(Number(valor) * 100) / 100;
  const precoMedio = centavos(produto.preco_medio);
  const precoMaiorSku = centavos(produto.preco_maior_sku);
  // Zero, negativo ou não numérico (já em centavos) também não é referência.
  const valido = valor => Number.isFinite(valor) && valor > 0;
  if (!valido(precoMedio) || !valido(precoMaiorSku)) return null;
  return { precoMedio, precoMaiorSku };
};

export const rotuloPlanilha = base => `planilha ${base?.horario ?? ""}`.trim();

// Só produtos com referência válida: o reset não descarta edição de produto sem preço na planilha.
export const produtosDaPlanilha = base =>
  base?.disponivel
    ? Object.keys(base.produtos || {})
        .map(id => Number(id))
        .filter(id => valoresDaPlanilha(base, id) != null)
    : [];

export const avisoPlanilhaCarregada = base =>
  `Preços da planilha de ${base.horario} carregados em ${
    produtosDaPlanilha(base).length
  } produtos. Nada foi publicado ainda.`;
